import { httpClient } from '@/shared/services/http-client'
import { mapState, Store } from 'vuex';
import { loadingService } from '@/shared/services/loading-service';

export const adminState = {
  namespaced: true,
  state: {
    adminTreeJsonData: null,
    adminUserGroupJsonData: null,
    adminEntityList: null,
    adminGroupList: null,
    adminReportList: null
  },
  mutations: {
    setAdminTreeData(state: any, data: any) { state.adminTreeJsonData = data; },
    setAdminUserGroupJsonData(state: any, data: any) { state.adminUserGroupJsonData = data; },
    setAdminEntityList(state: any, data: any) { state.adminEntityList = data; },
    setAdminGroupList(state: any, data: any) { state.adminGroupList = data; },
    updateAdminEntityList(state: any, data: any) { state.adminEntityList.entities = data; },
    setAdminReportList(state: any, data: any) { state.adminReportList = data; },
    setDomainWhitelist(state: any, data: any) { state.domainWhitelist = data; },
    setSelectedUsers(state: any, data: any) { state.adminUserGroupJsonData.selected_users = data; },
    setSelectedPermissions(state: any, data: any) { state.adminUserGroupJsonData.selected_permissions = data; },
    setGroupInfoDescription(state: any, data: any) { state.adminUserGroupJsonData.groupInfo.description = data; },
    setAvailableUsers(state: any, data: any) { state.adminUserGroupJsonData.available_users = data; }
  },
  actions: {
    async getAdminTreeJsonData(context: any) {
      const url = `/admintree`;
      const adminTreeJson = await httpClient.get(url);
      if (adminTreeJson['data']) {
        context.commit('setAdminTreeData', adminTreeJson['data'])
      }
    },
    async getAdminUserGroupJsonData(context: any, param: any) {
      if (this.state.admin.adminUserGroupJsonData != null) {
        context.commit('setAdminUserGroupJsonData', null);
      }
      const industry_id = param['industry_id']
      const entity_id = param['entity_id']
      const usergroup_id = param['usergroup_id']
      const url = `/admingroup/${entity_id}?group_id=${usergroup_id}`
      const adminUserGroupJson = await httpClient.get(url)
      if (adminUserGroupJson['data']) {
        context.commit('setAdminUserGroupJsonData', adminUserGroupJson['data'])
      }
    },
    /**
     * @api /api/usergroups
     * @query {industry_id, entity_id, entitygroup_id, username}
     * @param context any
     * @param param any
     */
    async addUserToUserGroup(context: any, param: any) {
      const industry_id = param['industry_id']
      const entity_id = param['entity_id']
      const usergroup_id = param['usergroup_id']
      const user_id = param['user_id']

      const url = `/usergroups?industry_id=${industry_id}&entity_id=${entity_id}&entitygroup_id=${usergroup_id}&username=${user_id}`

      const addUserToUserGroupResponse = await httpClient.post(url)
      // check response from post request 

      if (addUserToUserGroupResponse.data) {
        // const updatedState = this.state.admin.adminUserGroupJsonData;
        // updatedState.selected_users = addUserToUserGroupResponse.data.selected_users;
        // context.commit('setAdminUserGroupJsonData', updatedState);
        context.commit('setSelectedUsers', addUserToUserGroupResponse.data.selected_users)
      }
    },
    /**
     * @api /api/usergroups
     * @query {industry_id, entity_id, entitygroup_id, username}
     * @param context any
     * @param param any
     */
    async removeUserToUserGroup(context: any, param: any) {
      const industry_id = param['industry_id']
      const entity_id = param['entity_id']
      const usergroup_id = param['usergroup_id']
      const user_id = param['user_id']

      const url = `/usergroups?industry_id=${industry_id}&entity_id=${entity_id}&entitygroup_id=${usergroup_id}&username=${user_id}`

      const removeUserFromUserGroupResponse = await httpClient.delete(url)
      // check response from post request 

      if (removeUserFromUserGroupResponse.data) {
        // const updatedState = this.state.admin.adminUserGroupJsonData;
        // updatedState.selected_users = removeUserFromUserGroupResponse.data.selected_users;
        // context.commit('setAdminUserGroupJsonData', updatedState);
        context.commit('setSelectedUsers', removeUserFromUserGroupResponse.data.selected_users)
      }
    },
    /**
     * @api /api/permissions
     * @query {industry_id, entity_id, entitygroup_id, username}
     * @param context any
     * @param param any
     */
    async addPermissionToUserGroup(context: any, param: any) {
      const industry_id = param['industry_id']
      const entity_id = param['entity_id']
      const usergroup_id = param['usergroup_id']
      const permission_id = param['permission_id']

      const url = `/permissions?industry_id=${industry_id}&entity_id=${entity_id}&entitygroup_id=${usergroup_id}&permission_id=${permission_id}`

      const addPermissionToUserGroupResponse = await httpClient.post(url)
      // check response from post request 

      if (addPermissionToUserGroupResponse.data) {
        // const updatedState = this.state.admin.adminUserGroupJsonData;
        // updatedState.selected_permissions = addPermissionToUserGroupResponse.data.selected_permissions;
        // context.commit('setAdminUserGroupJsonData', updatedState);
        context.commit('setSelectedPermissions', addPermissionToUserGroupResponse.data.selected_permissions)
      }
    },
    async removePermissionFromUserGroup(context: any, param: any) {
      const industry_id = param['industry_id']
      const entity_id = param['entity_id']
      const usergroup_id = param['usergroup_id']
      const permission_id = param['permission_id']

      const url = `/permissions?industry_id=${industry_id}&entity_id=${entity_id}&entitygroup_id=${usergroup_id}&permission_id=${permission_id}`

      const removePermissionFromUserGroupResponse = await httpClient.delete(url)
      // check response from post request 

      if (removePermissionFromUserGroupResponse['data']) {
        // const updatedState = this.state.admin.adminUserGroupJsonData;
        // updatedState.selected_permissions = removePermissionFromUserGroupResponse.data.selected_permissions;
        // context.commit('setAdminUserGroupJsonData', updatedState);
        context.commit('setSelectedPermissions', removePermissionFromUserGroupResponse.data.selected_permissions)
      }
    },
    async addNewUserGroup(context: any, param: any) {
      const industry_id = param['industry_id']
      const entity_id = param['entity_id']
      const usergroup_name = param['usergroup_name']
      const usergroup_description = param['usergroup_description']

      const url = `/groups?entity_id=${entity_id}&name=${usergroup_name}&description=${usergroup_description}`
      const addUserGroupReponse = await httpClient.post(url)

      if (addUserGroupReponse['data']) {
        context.commit('setAdminGroupList', addUserGroupReponse['data']);
      }
    },
    async editUserGroup(context: any, param: any) {
      const industry_id = param['industry_id'] //unused
      const entity_id = param['entity_id']
      const usergroup_id = param['usergroup_id']
      const usergroup_name = param['usergroup_name']
      const usergroup_description = param['usergroup_description']

      const url = `/groups?entity_id=${entity_id}&entitygroup_id=${usergroup_id}&name=${usergroup_name}&description=${usergroup_description}`;
      const editUserGroupReponse = await httpClient.patch(url)
      if (editUserGroupReponse['data']) {
        context.commit('setAdminGroupList', editUserGroupReponse['data'])

        const updatedState = this.state.admin.adminUserGroupJsonData;
        if (updatedState.profile.value) {
          const groupInfo = this.state.admin.adminGroupList.groups.find(el => el.id === updatedState.profile.value);
          if (groupInfo) {
            // updatedState.profile.label = groupInfo.name;
            // updatedState.profile.description = groupInfo.description;
            // context.commit('setAdminUserGroupJsonData', updatedState);
            context.commit('setGroupInfoDescription', groupInfo.description)
          }
        }
      }
    },
    async deleteUserGroup(context: any, param: any) {
      const industry_id = param['industry_id'] //unused
      const entity_id = param['entity_id']
      const usergroup_id = param['usergroup_id']

      // 'entitygroup_id','name','description'
      const url = `/groups?entity_id=${entity_id}&entitygroup_id=${usergroup_id}`
      const deleteUserGroupReponse = await httpClient.delete(url)

      if (deleteUserGroupReponse['data']) {
        context.commit('setAdminGroupList', deleteUserGroupReponse['data']);
      }
    },
    async inviteNewUser(context: any, param: any) {
      const url = `/users`;
      loadingService.showLoading(true);

      return await httpClient.post(url, param)
        .then(res => {
          const data = res.data;
          const result = { 'success': true, 'errorMessage': '' };

          if (!data.message) {
            if (data.special_user && data.special_user === true) {
              //it was invite special user request
            }
            else {
              // const updatedState = this.state.admin.adminUserGroupJsonData;
              // updatedState.available_users = data.available_users;
              // this.$vaToast.init({
              //   message: 'User created successfully',
              //   iconClass: 'fa-check',
              //   position: 'bottom-right',
              //   duration: 1500,
              // })
              context.commit('setAvailableUsers', data.available_users);
            }
          }
          else if (data.statusCode === 405) {
            result.success = false;
            result.errorMessage = data.message;
          } else {
            result.success = false;
            result.errorMessage = 'Error sending invite user request';
          }
          return result;
        })
        .catch(err => {
          console.log(err);
          throw err; // reject
        })
        .finally(() => {
          loadingService.showLoading(false);
        })
    },
    async getAdminEntityList(context: any, param: any) {
      const entityId = param.entityId;
      const url = `/adminEntityList?entity_id=${entityId}`;
      return await httpClient.get(url)
        .then(res => {
          const data = res.data;
          const result = { 'success': true, 'errorMessage': '' };

          if (!data.message) {
            context.commit('setAdminEntityList', data);
            return result;
          }
          else {
            result.success = false;
            result.errorMessage = 'Error retrieve entity list';
          }
          return result;
        })
        .catch(err => {
          console.log(err);
          throw err; // reject
        })
    },
    async getAdminGroupList(context: any, param: any) {
      const entityId = param.entityId;

      const url = `/adminGroupList?entity_id=${entityId}`;
      const groupList = await httpClient.get(url);
      if (groupList['data']) {
        context.commit('setAdminGroupList', groupList['data'])
      }
    },
    async getAdminReportList(context: any, param: any) {
      const url = `/adminReportList?entity_id=${param.entityId}`;

      return await httpClient.get(url)
        .then(res => {
          const data = res.data;
          const result = { 'success': true, 'errorMessage': '' };

          if (!data.message) {
            context.commit('setAdminReportList', data);
            return result;
          }
          else {
            result.success = false;
            result.errorMessage = 'Error retrieve admin report list';
          }
          return result;
        })
        .catch(err => {
          console.log(err);
          throw err; // reject
        })
    },
    async getDomainWhitelist(context: any, param: any) {
      const url = `/adminDomainWhitelist?entity_id=${param.entityId}`;
      console.log(url)
      return await httpClient.get(url)
        .then(res => {
          const data = res.data;
          const result = { 'success': true, 'errorMessage': '' };

          if (!data.message) {
            context.commit('setDomainWhitelist', data);
            return result;
          }
          else {
            result.success = false;
            result.errorMessage = 'Error fetching admin domain whitelist';
          }
          return result;
        })
        .catch(err => {
          console.log(err);
          throw err; // reject
        })
    },
    async addNewReport(context: any, param: any) {
      const url = `/reports`;
      loadingService.showLoading(true);

      return await httpClient.post(url, param)
        .then(res => {
          const data = res.data;
          const result = { 'success': true, 'errorMessage': '' };
          console.log(data);
          if (!data.message) {
            const newReport = data.report;
            if (newReport && this.state.admin.adminReportList) {
              const currentReports = [...this.state.admin.adminReportList.reports]
              let report = currentReports.find(r => r.id === newReport.id)
              if (report) {
                //shouldn't happen
                report = newReport
              }
              else {
                currentReports.push(newReport)
              }
              context.commit('setAdminReportList', { ...this.state.admin.adminReportList, ...{ reports: currentReports } })
            }
          }
          else {
            result.success = false;
            result.errorMessage = 'Error create new report';
          }
          return result;
        })
        .catch(err => {
          console.log(err);
          throw err; // reject
        })
        .finally(() => {
          loadingService.showLoading(false);
        })
    },
    async addNewDomain(context: any, param: any) {
      const url = `/adminDomainWhitelist?entity_id=${param.entityId}`;
      loadingService.showLoading(true);

      return await httpClient.post(url, param)
        .then(res => {
          const data = res.data;
          const result = { 'success': true, 'errorMessage': '', 'message': '' };
          if (!data.message) {
            context.commit('setDomainWhitelists', data);
            return result;
          } else {
            result.success = false;
            result.message = 'Error adding new domain';
          }
          return result;
        })
        .catch(err => {
          console.log(err);
          throw err; // reject
        })
        .finally(() => {
          loadingService.showLoading(false);
        })
    },
    async toggleDomainStatusFromWhitelist(context: any, param: any) {
      const url = `/adminDomainWhitelist?entityId=${param.entityId}&domainName=${param.domainName}`
      await httpClient.patch(url)
        .then(res => {
          const data = res.data;
          const result = { 'success': true, 'errorMessage': '', 'message': '' };
          if (!data.message) {
            context.commit('setDomainWhitelists', data);
            return result;
          } else {
            result.success = false;
            result.message = 'Error changing state of domain';
          }
          return result;
        })
        .catch(err => {
          console.log(err);
          throw err; // reject
        })
        .finally(() => {
          loadingService.showLoading(false);
        })
    },
    async deleteDomainFromWhitelist(context: any, param: any) {
      const url = `/adminDomainWhitelist?entityId=${param.entityId}&domainName=${param.domainName}`
      await httpClient.delete(url)
        .then(res => {
          const data = res.data;
          const result = { 'success': true, 'errorMessage': '', 'message': '' };
          if (!data.message) {
            const deletedDomain = data.domainWhitelist;
            if (deletedDomain && this.state.admin.domainWhitelist) {
              const currentDomains = [...this.state.admin.domainWhitelist.domainWhitelist]
              const domainIndex = currentDomains.findIndex(r => r.name === param.domainName)
              if (domainIndex !== -1) {
                currentDomains.splice(domainIndex, 1)
                context.commit('setDomainWhitelists', { ...this.state.admin.domainWhitelist, ...{ domains: currentDomains } })
              }
            }
          } else {
            result.success = false;
            result.message = 'Error deleting domain';
          }
          return result;
        })
        .catch(err => {
          console.log(err);
          throw err; // reject
        })
        .finally(() => {
          loadingService.showLoading(false);
        })
    },
    async updateReport(context, param) {
      const url = `/reports`;
      loadingService.showLoading(true);

      return await httpClient.patch(url, param)
        .then(res => {
          const data = res.data;
          const result = { 'success': true, 'errorMessage': '' };

          if (!data.message) {
            const newReport = data.report;
            if (newReport && this.state.admin.adminReportList) {
              const currentReports = [...this.state.admin.adminReportList.reports]
              const reportIndex = currentReports.findIndex(r => r.id === newReport.id)

              if (reportIndex !== -1) {
                currentReports[reportIndex] = { ...currentReports[reportIndex], ...newReport }
                context.commit('setAdminReportList', { ...this.state.admin.adminReportList, ...{ reports: currentReports } })
              }
            }
          }
          else {
            result.success = false;
            result.errorMessage = 'Error update report';
          }
          return result;
        })
        .catch(err => {
          console.log(err);
          throw err; // reject
        })
        .finally(() => {
          loadingService.showLoading(false);
        })
    },
    async deleteReport(context, param) {
      const url = `/reports`;
      loadingService.showLoading(true);

      return await httpClient.patch(url, param)
        .then(res => {
          const data = res.data;
          const result = { 'success': true, 'errorMessage': '' };

          if (!data.message) {
            const deletedReport = data.report;
            if (deletedReport && this.state.admin.adminReportList) {
              const currentReports = [...this.state.admin.adminReportList.reports]
              const reportIndex = currentReports.findIndex(r => r.id === deletedReport.id)

              if (reportIndex !== -1) {
                currentReports.splice(reportIndex, 1)
                context.commit('setAdminReportList', { ...this.state.admin.adminReportList, ...{ reports: currentReports } })
              }
            }
          }
          else {
            result.success = false;
            result.errorMessage = 'Error delete report';
          }
          return result;
        })
        .catch(err => {
          console.log(err);
          throw err; // reject
        })
        .finally(() => {
          loadingService.showLoading(false);
        })
    },
    clearAdminGroupList(context) {
      context.commit('setAdminGroupList', []);
    },
    clearAdminUserGroupJsonData(context) {
      context.commit('setAdminUserGroupJsonData', null);
    },
    updateAdminEntityList(context, param) {
      context.commit('updateAdminEntityList', param)
    }
  }
}
